import React, {Component} from 'react';
import {Col, Form, FormGroup, Radio} from "react-bootstrap";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import FirmyService from "../../../../../klienciConfig/firmy/FirmyService";
import {TopAlertInformacja, TopAlertOstrzezenie, TopAlertSukces, TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import FirmyForm from "../../../../../klienciConfig/firmy/components/FirmyForm";
import KlienciService from "../../../../../klienciConfig/KlienciService";
import Select from 'react-select'
import KlienciForm from "../../../../../klienciConfig/klienci/components/KlienciForm";
import BiletyService from "../../../biletyApi/BiletyService";


class BKWystawianieFaktury extends Component {

    constructor(props) {
        super(props);
        this.state = {

            typFaktury: 1, // 1- imienna , 2- vat

            klientDoFaktury: null,
            firmaDoFaktury: null,


            czyPokazacFormularzDodawaniaKlienta: false,
            czyPokazacFormularzDodawaniaFirmy: false,

            czyWystawionoFakture: null,
            loadingWystawianieFaktury: false,

        }
    }

    componentDidMount() {
        this.szukajIUstawFirmePoNipie(this.props.bilet.biletyPoz[0].nipParagon)
        this.szukajIUstawKlientaPoId(this.props.bilet.idKl)
    }

    onClickWystawFakture = () => {

        this.setState({czyWystawionoFakture: null})

        let czyPoprawne = true;
        let obj = null;

        if (this.state.typFaktury === 1) {
            //imienna
            if (!Boolean(this.state.klientDoFaktury)) {
                czyPoprawne = false;
            } else {
                if (this.state.klientDoFaktury.idKl === 1) {
                    czyPoprawne = false
                }

                obj = {
                    idBi: this.props.bilet.idBi,
                    idKl: this.state.klientDoFaktury.idKl
                }
            }
        } else {
            // na firme

            if (!Boolean(this.state.firmaDoFaktury)) {
                czyPoprawne = false;
            } else {
                obj = {
                    idBi: this.props.bilet.idBi,
                    idFi: this.state.firmaDoFaktury.idFi
                }
            }
        }

        if (czyPoprawne) {

            BiletyService.zamienParagonNaFakture(obj)
                .then(response => {

                    let czyOk = false;

                    if (response) {
                        if (response.status < 300) {
                            if (response.data) {
                                czyOk = true
                            }
                        }
                    }

                    if (czyOk) {
                        this.setState({
                            czyWystawionoFakture: (response.data[0].fsymnum + " " + response.data[0].tabf),
                            loadingWystawianieFaktury: false
                        })
                        this.props.pobierzPonownieWystawioneDokumenty();
                    } else {
                        this.setState({czyWystawionoFakture: 'error', loadingWystawianieFaktury: false})
                    }


                })
                .catch(error => {
                    this.setState({czyWystawionoFakture: 'error', loadingWystawianieFaktury: false})
                })


        } else {
            alert('Nie można wystawić faktury - proszę sprawdzić poprawność wprowadzonych danych')
        }
    };

    szukajIUstawKlientaPoId = (id) => {
        if (Boolean(id) && id !== 1) {
            KlienciService.getKlient(id)
                .then(response => {
                    console.log(response)
                    if (response)
                        if (response.data)
                            this.setState({
                                klientDoFaktury: Object.assign(response.data, {
                                    informacje: response.data.idKl + " " + response.data.imie + ' ' + response.data.nazwisko + ' ' + response.data.email
                                })
                            })
                })
                .catch(error => {
                    console.log(error)
                })
        }
    };

    szukajIUstawFirmePoNipie = (nip) => {
        if (Boolean(nip)) {
            FirmyService.szukajFirmePoNipieAlboPoNazwie(nip)
                .then(response => {
                    let czyZnaleziono = false;

                    if (response.data) {
                        if (response.data.content.length > 0) {
                            if (response.data.content.find(i => i.nip === nip)) {
                                czyZnaleziono = true
                            }
                        }
                    }

                    if (czyZnaleziono) {
                        this.setState({
                            firmaDoFaktury: response.data.content.find(i => i.nip === nip)
                        })
                    } else {
                        this.setState({
                            czyPokazacFormularzDodawaniaFirmy: true
                        })
                    }

                })
                .catch(error => {
                    console.log(error);
                    this.setState({
                        czyPokazacFormularzDodawaniaFirmy: true
                    })
                })
        }
    };

    onClickZapiszFirme = (obj) => {
        FirmyService.addFirma(obj).then(function (response) {
            if (response) {
                if (response.data) {
                    this.setState({
                        firmaDoFaktury: response.data,
                        czyPokazacFormularzDodawaniaFirmy: false
                    })
                }
            }
        })
    };

    onChangeKlientFormSelect = (e) => {
        if (e !== null) {
            this.szukajIUstawKlientaPoId(e.idKl)
        }
    };

    getKlienciForSelect = (input) => {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return KlienciService.getKlienciBezZdjec(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    imieNazwisko: (item.imie) ? item.imie + ' ' + item.nazwisko : '',
                    informacje: item.idKl + " " + item.imie + ' ' + item.nazwisko + ' ' + item.email
                }
            })
            return {options: arr}
        }.bind(this))
    };

    renderKlientOption = (option) => {
        return (
            <div>
                ID:<span className={'label label-ebus-default'}>{option.idKl}</span>
                <span style={{marginLeft: '10px'}}>{option.imie}</span>
                <span style={{marginLeft: '3px'}}>{option.nazwisko}</span>
                <span style={{marginLeft: '15px'}}><i className={'fa fa-envelope'}></i> {(option.email) ? option.email : '-'}</span>
                <span style={{marginLeft: '15px'}}><i className={'fa fa-phone'}></i> {(option.nrTel) ? option.nrTel : "-"}</span>
            </div>
        )
    }

    onClickZapiszNowegoKlienta = (klient) => {
        KlienciService.addKlient(klient).then(response => {
            if (response) {
                if (response.data) {
                    this.szukajIUstawKlientaPoId(response.data.idKl)
                    this.setState({czyPokazacFormularzDodawaniaKlienta: false})
                }
            }
        })
    };

    render() {

        const {bilet} = this.props;
        const czyMoznaFaktureVAT = Boolean(bilet.biletyPoz[0].nipParagon);
        const NIP = bilet.biletyPoz[0].nipParagon;
        const czyKlientJednorazowy = (bilet.idKl === 1);

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>Wystaw fakturę na bilet</div>
                    <Form horizontal={true}>
                        <TopAlertInformacja
                            text={czyMoznaFaktureVAT ? ("Możliwe jest wystawienie faktury imiennej lub faktury VAT na NIP: " + NIP) : "Możliwe jest wystawienie tylko faktury imiennej"}/>
                        {
                            czyKlientJednorazowy &&
                            <TopAlertOstrzezenie
                                text={'Bilet jest na klienta jednorazowego. W przypadku faktury imiennej, proszę wybrać klienta z bazy bądź dodać nowego klienta'}
                            />
                        }
                        <FormGroup>
                            <div style={{marginTop: '15px'}}>
                                <Col xs={12} lg={3}>
                                    <Radio
                                        name={'radiogroupWystawienieFaktury'}
                                        inline
                                        checked={(this.state.typFaktury === 1)}
                                        onChange={() => this.setState({typFaktury: 1})}
                                    >Faktura imienna</Radio>
                                    <Radio
                                        name={'radiogroupWystawienieFaktury'}
                                        inline
                                        checked={(this.state.typFaktury === 2)}
                                        onChange={() => this.setState({typFaktury: 2})}
                                        disabled={!czyMoznaFaktureVAT}
                                    >Faktura VAT</Radio>
                                </Col>

                                <Col xs={12} lg={6}>

                                    {   //faktura imienna
                                        (this.state.typFaktury === 1) &&
                                        <div>
                                            {
                                                Boolean(this.state.klientDoFaktury) ?
                                                    <div>
                                                        ID: <span className={'label label-ebus-default'}>{this.state.klientDoFaktury.idKl}</span>
                                                        <span style={{marginLeft: '10px'}}>{this.state.klientDoFaktury.imie}</span>
                                                        <span style={{marginLeft: '3px'}}>{this.state.klientDoFaktury.nazwisko},</span>
                                                        <span style={{marginLeft: '10px'}}>{this.state.klientDoFaktury.email}</span>
                                                        <span style={{marginLeft: '25px'}}>
                                                        <TopButtonAction
                                                            text={'zmień'}
                                                            iconType={'fa fa-edit'}
                                                            btnColor={'default'}
                                                            btnSize={'xs'}
                                                            onClick={() => {
                                                                this.setState({klientDoFaktury: null})
                                                            }}
                                                        />
                                                    </span>
                                                    </div>
                                                    :
                                                    <div>
                                                        <Select.Async
                                                            value={this.state.klientDoFaktury}
                                                            onChange={this.onChangeKlientFormSelect}
                                                            valueKey={"idKl"}
                                                            labelKey={"informacje"}
                                                            loadOptions={this.getKlienciForSelect}
                                                            clearable={false}
                                                            backspaceRemoves={true}
                                                            placeholder={'Szukaj po ID, imieniu, nazwisku, email'}
                                                            ignoreAccents={false}
                                                            valueRenderer={(option) => this.renderKlientOption(option)}
                                                            optionRenderer={(option) => this.renderKlientOption(option)}
                                                        />
                                                    </div>
                                            }
                                        </div>
                                    }

                                    {   //faktura VAT
                                        (this.state.typFaktury === 2 && czyMoznaFaktureVAT) &&
                                        <div>
                                            {
                                                (Boolean(this.state.firmaDoFaktury)) ?
                                                    <div>
                                                        <div>
                                                    <span className={'label label-ebus-primary'} title={'NIP'}>
                                                        {this.state.firmaDoFaktury.nip}
                                                        </span>
                                                            {this.state.firmaDoFaktury.nazwa}
                                                            {
                                                                this.state.firmaDoFaktury.idNabywcy &&
                                                                <span style={{color: 'grey', fontSize: '12px', marginLeft: '15px'}}>
                                                            <i className={'fa fa-info-circle'}></i> Tylko odbiorca!</span>
                                                            }
                                                        </div>
                                                        <div>
                                                            {(this.state.firmaDoFaktury.regon) && 'REGON: ' + this.state.firmaDoFaktury.regon}
                                                        </div>
                                                        <div>
                                                            {(this.state.firmaDoFaktury.wojewodztwo) && this.state.firmaDoFaktury.wojewodztwo}
                                                            {(this.state.firmaDoFaktury.kodPocztowy) && ', ' + this.state.firmaDoFaktury.kodPocztowy}
                                                            {(this.state.firmaDoFaktury.miejscowosc) && ', ' + this.state.firmaDoFaktury.miejscowosc}
                                                            {(this.state.firmaDoFaktury.ulica) && ', ' + this.state.firmaDoFaktury.ulica}
                                                            {(this.state.firmaDoFaktury.nrNieruchomosci) && ', ' + this.state.firmaDoFaktury.nrNieruchomosci}
                                                            {(this.state.firmaDoFaktury.nrLokalu) && '/' + this.state.firmaDoFaktury.nrLokalu}
                                                        </div>
                                                    </div>
                                                    :
                                                    <TopAlertUwaga
                                                        text={'Nie znaleziono firmy o tym nipie, proszę dodać firmę w formularzu poniżej'}/>
                                            }
                                        </div>
                                    }
                                </Col>

                                <Col xs={12} lg={3}>
                                    <TopButtonAction
                                        text={'Wystaw fakturę'}
                                        iconType={'fa fa-file-text-o'}
                                        onClick={this.onClickWystawFakture}
                                        btnDisabled={this.state.loadingWystawianieFaktury}
                                    />
                                    <div>
                                        {
                                            this.state.loadingWystawianieFaktury &&
                                            <span style={{marginLeft: '15px', color: 'grey', fontStyle: 'italic'}}>
                                            <i className={'fa fa-spinner fa-spin'}></i> trwa przetwarzanie żądania...
                                        </span>
                                        }
                                        {
                                            (this.state.czyWystawionoFakture !== null) &&
                                            <span>
                                                    {
                                                        this.state.czyWystawionoFakture !== 'error' ?
                                                            <TopAlertSukces inline={'true'}
                                                                            text={'Pomyślnie wystawiono fakturę: ' + this.state.czyWystawionoFakture + ' . Zaktualizowano tabelę wystawionych dokumentów'}/>
                                                            :
                                                            <TopAlertUwaga inline={'true'} text={'Wystąpił błąd przy próbie wystawienia faktury'}/>
                                                    }
                                                </span>

                                        }
                                    </div>
                                </Col>
                            </div>
                        </FormGroup>
                        {
                            (this.state.typFaktury === 1 && czyKlientJednorazowy) &&
                            <FormGroup>
                                <Col xs={12}>
                                    <TopButtonAction
                                        text={this.state.czyPokazacFormularzDodawaniaKlienta ? "Ukryj formularz dodawania nowego klienta" : "Pokaż formularz dodawania nowego klienta"}
                                        onClick={() => this.setState({czyPokazacFormularzDodawaniaKlienta: !this.state.czyPokazacFormularzDodawaniaKlienta})}
                                        btnColor={'default'}
                                        iconType={this.state.czyPokazacFormularzDodawaniaKlienta ? 'fa fa-eye-slash' : 'fa fa-eye'}
                                    />
                                    {
                                        this.state.czyPokazacFormularzDodawaniaKlienta &&
                                        <KlienciForm handleClickZapisz={this.onClickZapiszNowegoKlienta} disableAnuluj={true}/>
                                    }
                                </Col>
                            </FormGroup>
                        }

                        {
                            (this.state.typFaktury === 2 && czyMoznaFaktureVAT) &&
                            <FormGroup>
                                <Col xs={12}>
                                    {
                                        this.state.czyPokazacFormularzDodawaniaFirmy &&
                                        <FirmyForm
                                            nipFirmy={NIP}
                                            czyMoznaEdytowacNip={false}
                                            handleClickAnuluj={() => this.setState({czyPokazacFormularzDodawaniaFirmy: false})}
                                            handleClickZapisz={this.onClickZapiszFirme}
                                        />
                                    }
                                </Col>
                            </FormGroup>
                        }
                    </Form>
                </fieldset>
            </div>
        );
    }
}

export default BKWystawianieFaktury;


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/bilety_kod_z_paragonu_components/BKWystawianieFaktury.js